import { render } from "./MedicalIncidentReport.vue?vue&type=template&id=71b6b7eb&ts=true"
import script from "./MedicalIncidentReport.vue?vue&type=script&lang=ts"
export * from "./MedicalIncidentReport.vue?vue&type=script&lang=ts"

import "./MedicalIncidentReport.vue?vue&type=style&index=0&id=71b6b7eb&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__